module.exports = __webpack_public_path__ + "img/1.797c6af4.jpg";